import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { apiFetch } from "@/lib/api.js";
import { useAuth } from "@/auth/useAuth.js";

const SellerLead = z.object({
  id: z.string().uuid(),
  address: z.string(),
  city: z.string().nullable(),
  property_type: z.string(),
  mq: z.coerce.number().nullable(),
  rooms: z.coerce.number().nullable(),
  contact_name: z.string(),
  contact_email: z.string(),
  contact_phone: z.string().nullable(),
  status: z.string(),
  created_at: z.string(),
});
export type SellerLead = z.infer<typeof SellerLead>;

const Response = z.object({ items: z.array(SellerLead) });

export function useSellerLeads() {
  const { session } = useAuth();
  const token = session?.access_token;
  return useQuery({
    queryKey: ["seller_leads"],
    enabled: !!token,
    queryFn: async (): Promise<SellerLead[]> => {
      const r = await apiFetch("/api/v1/admin/seller-leads", token!, Response);
      return r.items;
    },
  });
}
